import { GDPR_REQUEST, GDPR_SUCCESS, GDPR_ERROR } from "./ActionType";

const initialState = {
  isRequest: false,
  isSuccess: false,
  isError: false,
  gdprData: {},
  error: null,
  latestRequestId: null,
};

const isStale = (state, action) =>
  Boolean(
    state.latestRequestId &&
      action.meta?.requestId &&
      state.latestRequestId !== action.meta.requestId
  );

const gdprDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case GDPR_REQUEST:
      return {
        ...state,
        isRequest: true,
        isSuccess: false,
        isError: false,
        gdprData: {},
        error: null,
        latestRequestId: action.meta?.requestId || null,
      };
    case GDPR_SUCCESS:
      if (isStale(state, action)) return state;
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        gdprData: action.payload,
        error: null,
        latestRequestId:
          action.meta?.requestId || state.latestRequestId || null,
      };
    case GDPR_ERROR:
      if (isStale(state, action)) return state;
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        gdprData: {},
        error: action.payload,
        latestRequestId:
          action.meta?.requestId || state.latestRequestId || null,
      };
    default:
      return state;
  }
};

export default gdprDataReducer;
